var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMicrophone = function SvgIconMicrophone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.25 6a4.75 4.75 0 0 1 9.5 0v5.25a4.75 4.75 0 1 1-9.5 0zM12 3.25A2.75 2.75 0 0 0 9.25 6v5.25a2.75 2.75 0 1 0 5.5 0V6A2.75 2.75 0 0 0 12 3.25",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 10.25a1 1 0 0 1 1 1 6.5 6.5 0 0 0 13 0 1 1 0 1 1 2 0 8.5 8.5 0 0 1-7.5 8.441v2.059a1 1 0 1 1-2 0v-2.059a8.5 8.5 0 0 1-7.5-8.441 1 1 0 0 1 1-1"
  }))));
};
export default SvgIconMicrophone;